import { FormControlLabel, ListItem, styled, Typography } from '@mui/material'

export const SettingItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
  transition: 'background-color 0.2s ease',

  '&:hover': {
    backgroundColor: theme.palette.grey[50],
  },

  '&:last-child': {
    borderBottom: 'none',
  },
}))

export const SettingLabel = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.text.primary,
}))

export const SettingToggle = styled(FormControlLabel)(({ theme }) => ({
  '.MuiSwitch-root': {
    '.MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: theme.palette.primary.main,

        '& + .MuiSwitch-track': {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
  },
}))
